import FinanceJobApproveOrReject from "@/components/dialog/FinanceJobApproveOrReject";
import JobJustificationDetails from "@/components/JobJustificationDetails";
import InvoiceSkeleton from "@/components/skeleton/InvoiceSkeleton";
import { STALE_TIME_INVOICE } from "@/constants";
import { UserContext } from "@/context/User/UserContext";
import { getJobJustificationById } from "@/services/hiring-justification-functions";
import { useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

const FinanceJobApproval = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const job = useQuery({
		queryKey: ["job", id],
		queryFn: () => getJobJustificationById(user?.accessToken!, id),
		enabled: !!user?.accessToken,
		staleTime: STALE_TIME_INVOICE,
		onSuccess: (data) => {
			console.log(data);
		},
	});

	return (
		<div className="max-w-5xl mx-auto p-4 rounded-md bg-white border mt-4">
			{job.isLoading ? (
				<InvoiceSkeleton />
			) : job.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error loading job.</h5>
				</div>
			) : (
				job.data && (
					<>
						<div className="flex gap-3 items-end justify-between">
							<h1 className="font-medium text-4xl">Job: {job.data.job}</h1>
							<FinanceJobApproveOrReject
								jobId={job.data.jobid}
								accessToken={user?.accessToken!}
							/>
						</div>
						{/* <InvoiceDetails invoice={job.data} accessToken={user?.accessToken!} /> */}
						<JobJustificationDetails job={job.data} />
					</>
				)
			)}
		</div>
	);
};

export default FinanceJobApproval;
